export default "__VITE_ASSET__19db9830__"